import { Plus } from "lucide-react";
import { Button } from "../../../../components/ui/common/button";

interface CompanyListHeaderProps {
  onRegisterClick: () => void;
}

/**
 * Page heading + "Add New Company" action, styled after `ProductListHeader`
 * (src/screens/lcaProduct/productList/components/ProductListHeader.tsx).
 */
const CompanyListHeader = ({ onRegisterClick }: CompanyListHeaderProps) => {
  return (
    <div className="tw-mb-6 tw-flex tw-items-center tw-justify-between tw-gap-4">
      <div>
        <h1 className="tw-font-display tw-text-2xl tw-font-bold tw-text-foreground">Companies</h1>
        <p className="tw-mt-1 tw-text-sm tw-text-muted-foreground">
          Registered companies, their contact details and the ingredient / process lists they can
          use
        </p>
      </div>
      <Button onClick={onRegisterClick} className="tw-shrink-0 tw-gap-2">
        <Plus className="tw-h-4 tw-w-4" />
        Register company
      </Button>
    </div>
  );
};

export default CompanyListHeader;
